import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponents = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 9,
      rows: 4,
      colSpan: {
        "0:0": 9,
        "3:1": 2,
        "3:3": 2,
        "3:5": 2,
        "3:7": 2,
      },
      rowsSize: [4, 1, 0.4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/wood-house.svg`,
                },
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/wood-wool.png`,
                  styles: {
                    minHeight: "74px",
                    minWidth: "84px",
                    maxHeight: "130px",
                    maxWidth: "130px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/timber-stud.png`,
                  styles: {
                    minHeight: "74px",
                    minWidth: "84px",
                    maxHeight: "130px",
                    maxWidth: "130px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/rigid-wood.png`,
                  styles: {
                    minHeight: "74px",
                    minWidth: "84px",
                    maxHeight: "130px",
                    maxWidth: "130px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/wood-fibre.png`,
                  styles: {
                    minHeight: "74px",
                    minWidth: "84px",
                    maxHeight: "130px",
                    maxWidth: "130px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/wood-1.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingTop: "5%",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/wood-2.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingTop: "5%",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/wood-3.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingTop: "5%",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/wood-4.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingTop: "5%",
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "<b>Wood wool</b> having porous absorption properties (can be exposed with a glass fibre cloth)",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 3% 0 0",
                justifyContent: "flex-start",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Timber stud</b> used for building structures",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 3% 0 0",
                justifyContent: "flex-start",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Rigid wood fibre boards</b> adding mass to partitions",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 3% 0 0",
                justifyContent: "flex-start",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Wood fibre panels</b> having porous absorption properties (can be exposed)",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 25% 0 0",
                justifyContent: "flex-start",
              },
            },
          },
        ],
      ],
    },
  },
};

export default components;
